import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_ENDPOINT } from "../../../services/api/resources";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import classes from "./ThreeWayMatching.module.css";
import Dbutton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import plusIcon from "../../../assets/images/svg/plusIcon.png";
import SearchBar from "../../../components/common/SearchBar/SearchBar";
import { AddCircleOutline, Close, DeleteOutline, MoreHoriz } from "@mui/icons-material";
import DButtonOutlined from "../../../components/Dashboard/DashboardButtons/dButtonOutlined";
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import SelectCountry from "../../../components/Dashboard/amount/SelectCountry";
import { Autocomplete, Box, Fade, Modal, TextField, Tooltip } from "@mui/material";
import { CurrencyContext } from "../../../context/CurrencyContext";
import { emptyCheck } from "../../../utils/validations";
import PopupFrame from "../../../components/Popups/PopupFrame/PopupFrame";
import { getUniqueData } from "../../../utils/getUniqueData";
import DataTable from "../../../components/common/DataTable/DataTable";
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import InfoLabel from "../../../components/common/InfoLabel/InfoLabel";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import { formatInrAmount } from "../../../utils/currencyFormat";
import PaginationComponent from "../../../components/common/Pagination/PaginationComponent";
import { previouPageClick, nextPageClick } from "../../../utils/pagination";

const PAGE_SIZE = 10;
const STAGE_NAME_MAX_LENGTH = 30;
const SERVER_SORTABLE_FIELDS = ["price_start", "price_end", "created_at"];

const getListRecords = (payload) => {
  if (Array.isArray(payload?.response)) return payload.response;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.records)) return payload.records;
  return [];
};

const getListPagination = (payload, fallbackLength = 0) => {
  const currentPageCount = Number(
    payload?.current_page_count ?? payload?.page_size ?? PAGE_SIZE,
  );
  const totalCount = Number(
    payload?.total_count ?? payload?.count ?? fallbackLength,
  );
  const pageCount = Number(
    payload?.page_count ??
      payload?.total_pages ??
      (currentPageCount > 0 ? Math.ceil(totalCount / currentPageCount) : 0),
  );

  return {
    total_count: Number.isFinite(totalCount) ? totalCount : fallbackLength,
    current_page_count: Number.isFinite(currentPageCount)
      ? currentPageCount
      : fallbackLength,
    page_count: Number.isFinite(pageCount) ? pageCount : 0,
  };
};

export default function TWMSlabConfig() {
  const loginData = useSelector((state) => state.loginData.value);
  const [auth_token] = useState(loginData?.auth_token);
  const [user_token] = useState(loginData?.user?.token);

  const [openapprovalmodal, setOpenApprovalModal] = useState(false);
  const [successpopup, setSuccessPopUp] = useState(false);
  const [openViewItemPopup, setOpenViewItemPopup] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);

  const [getuserlist, setUserList] = useState([]);
  const [selectedApprovers, setSelectedApprovers] = useState([]);
  const [approvers, setApprovers] = useState([]);
  const [configUsers, setConfigUsers] = useState([]);

  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [departmentList, setDepartmentList] = useState([]);
  const [departmentError, setDepartmentError] = useState(false);
  const [approverError, setApproverError] = useState(false);

  const normalizeDepartment = (value) => String(value || "").trim().toLowerCase();
  const selectedMatrixUsers = [
    ...selectedApprovers,
    ...approvers
      .map((approver) => getuserlist.find((user) => user.token === approver.value))
      .filter(Boolean),
  ];
  const selectedDepartmentNames = [
    ...new Set(selectedMatrixUsers.map((user) => String(user?.department || "").trim()).filter(Boolean)),
  ];
  const visibleDepartments = selectedDepartmentNames.length
    ? departmentList.filter((department) =>
        selectedDepartmentNames.some(
          (name) => normalizeDepartment(name) === normalizeDepartment(department?.name),
        ),
      )
    : departmentList;
  const activeDepartmentName =
    selectedDepartment?.name || selectedDepartmentNames[0] || "";
  const visibleApprovers = activeDepartmentName
    ? getuserlist.filter(
        (user) =>
          normalizeDepartment(user?.department) ===
          normalizeDepartment(activeDepartmentName),
      )
    : getuserlist;

  const syncDepartmentFromUsers = (users = []) => {
    const departmentName = users.find((user) => user?.department)?.department;
    if (!departmentName) return;
    const match = departmentList.find(
      (department) =>
        normalizeDepartment(department?.name) === normalizeDepartment(departmentName),
    );
    if (match) setSelectedDepartment(match);
  };

  const handleDepartmentChange = (newDepartment) => {
    setSelectedDepartment(newDepartment);
    setDepartmentError(false);
    if (!newDepartment?.name) return;
    const departmentName = normalizeDepartment(newDepartment.name);
    setSelectedApprovers((current) =>
      current.filter(
        (user) => normalizeDepartment(user?.department) === departmentName,
      ),
    );
  };

  const getAdditionalApproverOptions = (currentToken = "") => {
    const selectedTokens = [
      ...selectedApprovers.map((user) => user.token),
      ...approvers.map((approver) => approver.value),
    ].filter((token) => token && token !== currentToken);
    return getuserlist.filter((user) => !selectedTokens.includes(user.token));
  };

  const [searchQuery, setSearchQuery] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [sortingColumnName, setSortingColumnName] = useState("created_at");
  const [sortingOrder, setSortingOrder] = useState("desc");
  const [paginationData, setPaginationData] = useState({
    total_count: 0,
    current_page_count: 0,
    page_count: 0,
  });

  const [uniqueData, setUniqueData] = useState();
  const { fromCurrency, setFromCurrency } = useContext(CurrencyContext);

  const [startPrice, setStartPrice] = useState({
    value: "",
    isValid: true,
  });
  const [endPrice, SetEndPrice] = useState({
    value: "",
    isValid: true,
  });
  const [stageName, setStageName] = useState({
    value: "",
    isValid: true,
  });

  const [getsavedposlab, setSavedPOSlab] = useState([]);

  const [editSlabId, setEditSlabId] = useState(null);

  const getAllUserList = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.all_user_list}`,
        { buyer_token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      const filteredUsers = response?.data.filter(
        (user) => user.token !== user_token,
      );

      setUserList(filteredUsers);
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  const getAllDepartment = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.get_Department}`,
        { user_token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      setDepartmentList(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  const handleGetTWMslab = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.get_all_twm_slab}`,
        {
          admin_token: user_token,
          page: pageNumber,
          page_size: PAGE_SIZE,
          sort_by: sortingColumnName || "created_at",
          sort_order: sortingOrder || "desc",
        },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      const records = getListRecords(response?.data);
      setConfigUsers(records);
      setPaginationData(getListPagination(response?.data, records.length));
    } catch (error) {
      console.log("error");
      setConfigUsers([]);
      setPaginationData({
        total_count: 0,
        current_page_count: 0,
        page_count: 0,
      });
    }
  };

  useEffect(() => {
    getAllUserList();
    getAllDepartment();
  }, []);

  useEffect(() => {
    if (!user_token) return;
    handleGetTWMslab();
  }, [user_token, pageNumber, sortingColumnName, sortingOrder]);

  const handleOpenAddItem = () => {
    setOpenApprovalModal(true);
  };

  const resetFormFields = () => {
    setStageName({ value: "", isValid: true });
    setStartPrice({ value: "", isValid: true });
    SetEndPrice({ value: "", isValid: true });
    // setFromCurrency({
    //     currency: "",
    //     countryName: ""
    // });
    setSelectedApprovers([]);
    setApprovers([]);
    setSelectedDepartment(null);
    setDepartmentError(false);
    setApproverError(false);
  };

  const handleCloseAddItem = () => {
    resetFormFields();
    setOpenApprovalModal(false);
    setIsEditMode(false);
  };

  const handleTWMdata = async () => {
    let isValid = true;

    if (!stageName.value.trim()) {
      setStageName((prev) => ({ ...prev, isValid: false }));
      isValid = false;
    } else {
      setStageName((prev) => ({ ...prev, isValid: true }));
    }

    if (!startPrice.value) {
      setStartPrice((prev) => ({ ...prev, isValid: false }));
      isValid = false;
    } else {
      setStartPrice((prev) => ({ ...prev, isValid: true }));
    }

    if (
      !endPrice.value ||
      parseFloat(endPrice.value) <= parseFloat(startPrice.value)
    ) {
      SetEndPrice((prev) => ({ ...prev, isValid: false }));
      isValid = false;
    } else {
      SetEndPrice((prev) => ({ ...prev, isValid: true }));
    }

    if (!selectedDepartment?.name) {
      setDepartmentError(true);
      isValid = false;
    } else {
      setDepartmentError(false);
    }

    if (selectedApprovers.length === 0) {
      setApproverError(true);
      isValid = false;
    } else {
      setApproverError(false);
    }

    const validatedApprovers = approvers.map((approver) => ({
      ...approver,
      isValid: Boolean(approver.value),
    }));
    if (validatedApprovers.some((approver) => !approver.isValid)) {
      setApprovers(validatedApprovers);
      isValid = false;
    } else {
      setApprovers(validatedApprovers);
    }

    if (!isValid) return;

    try {
      const level1UserTokens = selectedApprovers.map((user) => user.token);
      const levelNUserTokens = approvers
        .map((approver) => approver.value)
        .filter(Boolean);
      const allUserTokens = [...level1UserTokens, ...levelNUserTokens];

      const formData = new FormData();
      formData.append("stage_name", stageName.value);
      formData.append("price_start", startPrice.value);
      formData.append("price_end", endPrice.value);
      formData.append("currency", fromCurrency.currency || "");
      formData.append("country_name", fromCurrency.countryName || "");
      formData.append("users", JSON.stringify(allUserTokens));
      formData.append("admin_token", user_token);
      formData.append("dept_name", selectedDepartment?.name || "");

      if (isEditMode && editSlabId) {
        formData.append("id", editSlabId);
      }

      const response = await axios.post(
        API_ENDPOINT.ins_twm_slab_config,
        formData,
        {
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        setOpenApprovalModal(false);
        setSuccessPopUp(true);
      }
    } catch (error) {
      console.error(
        "Error saving PR slab:",
        error.response?.data || error.message
      );
      alert("Something went wrong while saving the slab.");
    }
  };

  const viewTextActionButtons = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleCloseAddItem}
      btnWidth={"16rem"}
      btnHeight={"4rem"}
    />,
    <Dbutton
      label={`${isEditMode ? "Update Slab Range" : "Add Slab Range"}`}
      btnWidth={"16rem"}
      btnHeight={"4rem"}
      onClick={handleTWMdata}
      // disabled={sendmsg && !errorMessages}
    />,
  ];

  const handleAddApprover = () => {
    const updated = [...approvers];
    if (updated.length > 0) {
      updated[updated.length - 1].showAdd = false;
    }
    updated.push({
      id: approvers.length + 1,
      value: "",
      department: null,
      isValid: true,
      showAdd: true,
    });
    setApprovers(updated);
  };

  const handleRemoveApprover = (id) => {
    const updated = approvers.filter((item) => item.id !== id);
    if (updated.length > 0) {
      updated[updated.length - 1].showAdd = true;
    }
    setApprovers(updated);
  };

  const getInitials = (name = "") =>
    String(name)
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase() || "")
      .join("") || "AP";

  const activeApproverEntries = [
    ...selectedApprovers.map((user) => ({
      key: `selected-${user.token}`,
      kind: "selected",
      token: user.token,
      name: `${user.first_name || ""} ${user.last_name || ""}`.trim() || "Approver",
      meta: `Dept: ${user.department || "-"}${user.designation ? ` - ${user.designation}` : ""}`,
    })),
    ...approvers
      .map((approver) => {
        const user = getuserlist.find((entry) => entry.token === approver.value);
        if (!user) return null;
        return {
          key: `extra-${approver.id}`,
          kind: "extra",
          rowId: approver.id,
          name: `${user.first_name || ""} ${user.last_name || ""}`.trim() || "Approver",
          meta: `Dept: ${user.department || approver.department?.name || "-"}${
            user.designation ? ` - ${user.designation}` : ""
          }`,
        };
      })
      .filter(Boolean),
  ];

  const handleRemoveActiveApprover = (entry) => {
    if (entry.kind === "selected") {
      setSelectedApprovers((current) =>
        current.filter((user) => user.token !== entry.token),
      );
      return;
    }
    handleRemoveApprover(entry.rowId);
  };

  const renderApproverInputs = () => {
    return approvers.map((approver, index) => (
      <div
        key={approver.id}
        className={classes.approverFieldWrapper}
      >
        <div className={classes.approverFieldInput}>
        <Autocomplete
          disablePortal
          options={departmentList}
          sx={{ width: "100%" }}
          getOptionLabel={(option) => option?.name || ""}
          value={
            approver.department ||
            departmentList.find(
              (department) =>
                normalizeDepartment(department?.name) ===
                normalizeDepartment(
                  getuserlist.find((user) => user.token === approver.value)
                    ?.department,
                ),
            ) ||
            null
          }
          onChange={(event, newDepartment) => {
            const updated = [...approvers];
            const selectedUser = getuserlist.find(
              (user) => user.token === updated[index].value,
            );
            updated[index].department = newDepartment;
            if (
              selectedUser &&
              normalizeDepartment(selectedUser?.department) !==
                normalizeDepartment(newDepartment?.name)
            ) {
              updated[index].value = "";
              updated[index].isValid = false;
            }
            setApprovers(updated);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={
                <>
                  Department <span className={classes.requiredMark}>*</span>
                </>
              }
              placeholder="Select department"
            />
          )}
        />
        <Autocomplete
          disablePortal
          options={getAdditionalApproverOptions(approver.value).filter(
            (user) =>
              !approver.department?.name ||
              normalizeDepartment(user?.department) ===
                normalizeDepartment(approver.department.name),
          )}
          sx={{ width: "100%" }}
          getOptionLabel={(option) =>
            `${option.first_name}-${option.designation || ""}`
          }
          value={getuserlist.find((u) => u.token === approver.value) || null}
          onChange={(event, newValue) => {
            const updated = [...approvers];
            updated[index].value = newValue?.token || "";
            updated[index].isValid = Boolean(newValue?.token);
            if (newValue?.department) {
              updated[index].department =
                departmentList.find(
                  (department) =>
                    normalizeDepartment(department?.name) ===
                    normalizeDepartment(newValue.department),
                ) || null;
            }
            setApprovers(updated);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={
                <>
                  {`Approver ${index + 2}`} <span className={classes.requiredMark}>*</span>
                </>
              }
              placeholder="Choose user"
              error={!approver.isValid}
              helperText={!approver.isValid ? "Approver is required" : ""}
            />
          )}
        />
        </div>
        <div className={classes.approverFieldButtonRow}>
          <Dbutton
            labelImg={<DeleteOutline />}
            customClass={classes.removeActionButton}
            iconWidth="2rem"
            iconHeight="2rem"
            btnWidth="4.4rem"
            btnHeight="4.4rem"
            tooltipMessage="Remove approver"
            onClick={() => handleRemoveApprover(approver.id)}
          />
          {approver.showAdd ? (
            <Dbutton
              labelImg={<AddCircleOutline />}
              customClass={classes.addActionButton}
              iconWidth="2rem"
              iconHeight="2rem"
              btnWidth="4.4rem"
              btnHeight="4.4rem"
              tooltipMessage="Add approver"
              onClick={handleAddApprover}
            />
          ) : null}
        </div>
      </div>
    ));
  };

  const PoslabItemInputs = [
    <div key="twm-slab-details" className={classes.slabSection}>
      <div className={classes.slabSectionHeader}>
        <p className={classes.slabSectionTitle}>Slab Details</p>
      </div>
      <div className={classes.slabFieldRow}>
        <DTextInput label="Stage Name" required={true} type="text" maxLength={STAGE_NAME_MAX_LENGTH} value={stageName.value} onChange={(e) => {
          const val = e.target.value.slice(0, STAGE_NAME_MAX_LENGTH);
          setStageName({
            value: val,
            isValid: emptyCheck(val),
          });
        }} error={!stageName.isValid} customClassName={classes.popupFields} errorMsg="Stage Name is required" size={"100%"} />
        <SelectCountry customClass={classes.approvercountry} value={fromCurrency} setValue={setFromCurrency} label={<>
          Currency <span className={classes.requiredMark}>*</span>
        </>} width={"100%"} onChange={(newCurrency) => {
          setFromCurrency({
            ...newCurrency,
          });
        }} />
        <DTextInput label="Start Price" required={true} type="number" value={startPrice.value} onChange={(e) =>
          setStartPrice({
            value: e.target.value,
            isValid: emptyCheck(e.target.value),
          })
        } error={!startPrice.isValid} customClassName={classes.popupFields} errorMsg="Start Price required" size={"100%"} />
        <DTextInput label="End Price" required={true} type="number" value={endPrice.value} onChange={(e) =>
          SetEndPrice({
            value: e.target.value,
            isValid: emptyCheck(e.target.value),
          })
        } error={!endPrice.isValid} customClassName={classes.popupFields} errorMsg={endPrice.value !== "" &&
          Number(endPrice.value) <= Number(startPrice.value)
            ? "End Price should be higher than Start Price"
            : "End Price required"} size={"100%"} />
      </div>
    </div>,
    <div key="twm-approver-config" className={classes.slabSection}>
      <div className={classes.slabSectionHeader}>
        <p className={classes.slabSectionTitle}>Approver Configuration</p>
      </div>
      <div className={classes.approverConfigCard}>
        <div className={classes.slabFieldRow}>
          <Autocomplete disablePortal options={visibleDepartments} getOptionLabel={(option) => option?.name || ""} value={selectedDepartment} onChange={(e, newVal) => handleDepartmentChange(newVal)} renderInput={(params) => (
            <TextField {...params} label={<>
              Department <span className={classes.requiredMark}>*</span>
            </>} placeholder="Select department" error={departmentError} helperText={departmentError ? "Department is required" : ""} sx={{
              '& .MuiInputBase-root': { fontSize: '14px', fontFamily: 'gilroyMedium' },
              '& .MuiInputLabel-root': { fontSize: '14px', fontFamily: 'gilroyMedium' },
              '& .MuiAutocomplete-tag': { fontSize: '12px', fontFamily: 'gilroyMedium' },
            }} />
          )} />
          <Autocomplete multiple disablePortal options={visibleApprovers} getOptionLabel={(option) =>
            option
              ? `${option.first_name || "N/A"} - ${option.designation || ""}`
              : ""
          } value={selectedApprovers} onChange={(event, newValue) => {
            setSelectedApprovers(newValue);
            setApproverError(false);
            syncDepartmentFromUsers(newValue);
          }} renderInput={(params) => (
            <TextField {...params} label={<>
              Approver <span className={classes.requiredMark}>*</span>
            </>} placeholder="Select approver" error={approverError} helperText={approverError ? "Approver is required" : ""} sx={{
              "& .MuiInputBase-root": { fontSize: "14px", fontFamily: "gilroyMedium" },
              "& .MuiInputLabel-root": { fontSize: "14px", fontFamily: "gilroyMedium" },
              "& .MuiAutocomplete-tag": { fontSize: "12px", fontFamily: "gilroyMedium" },
            }} />
          )} />
        </div>
        <div key="twm-add-approver-action" className={classes.approverActionRow}>
          <Dbutton
            labelImg={<AddCircleOutline />}
            customClass={classes.addApproverIconButton}
            iconWidth="2rem"
            iconHeight="2rem"
            btnWidth="4.4rem"
            btnHeight="4.4rem"
            tooltipMessage="Add approver"
            onClick={handleAddApprover}
          />
        </div>
        {approvers.length > 0 && (
          <div key="twm-additional-approvers" className={classes.additionalApproversSection}>
            {renderApproverInputs()}
          </div>
        )}
      </div>
    </div>,
    <div key="twm-active-approvers" className={classes.activeApproversSection}>
      <div className={classes.slabSectionHeader}>
        <p className={classes.activeApproverEyebrow}>
          Active Approvers ({activeApproverEntries.length})
        </p>
      </div>
      <div className={classes.activeApproverList}>
        {activeApproverEntries.length > 0 ? activeApproverEntries.map((entry, index) => (
          <div key={entry.key} className={classes.activeApproverItem}>
            <div className={`${classes.activeApproverAvatar} ${index % 2 === 0 ? classes.activeApproverAvatarPrimary : classes.activeApproverAvatarAccent}`}>
              {getInitials(entry.name)}
            </div>
            <div className={classes.activeApproverContent}>
              <p className={classes.activeApproverName}>{entry.name}</p>
              <p className={classes.activeApproverMeta}>{entry.meta}</p>
            </div>
            <button type="button" className={classes.activeApproverRemove} onClick={() => handleRemoveActiveApprover(entry)}>
              <Close sx={{ fontSize: 16 }} />
            </button>
          </div>
        )) : (
          <div className={classes.activeApproverEmpty}>
            No approvers added yet. Configure one above to build the approval chain.
          </div>
        )}
      </div>
    </div>,
  ];

  const Tableheadings = [
    {
      label: "Name",
      field: "stageNameDisplay",
      col_width: "280px",
      minWidth: "280px",
      noWrap: true,
      sortable: false,
    },
    { label: "Users", field: "users", sortable: false },
    // { label: "Department", field: "department" },
    { label: "Currency", field: "currency_type", sortable: false },
    { label: "Start Price", field: "price_start", additional_data: "currency" },
    { label: "End Price", field: "price_end", additional_data: "currency" },
     { label: "Created Date", field: "created_at", additional_data: "date" },
  ];

  const itemsData = configUsers;

  const processedItemsData = itemsData.map((item) => ({
    ...item,
    stageNameDisplay: (
      <Tooltip
        title={String(item?.slab_name || "-")}
        arrow
        placement="top"
        enterDelay={250}
        componentsProps={{
          tooltip: {
            className: classes.stageNameTooltip,
            sx: {
              fontSize: "14px",
              lineHeight: 1.45,
              padding: "8px 12px",
              maxWidth: "42rem",
              overflowWrap: "anywhere",
              wordBreak: "break-word",
            },
          },
          arrow: {
            className: classes.stageNameTooltipArrow,
            sx: { fontSize: "18px" },
          },
        }}
      >
        <span className={classes.stageNameCell}>{item?.slab_name || "-"}</span>
      </Tooltip>
    ),
    department: item.department || item.dept_name || "",
    usersList: item.users, // keep original object array for modal
    users: item.users.map((user) => user.approver_name).join(", "), // string for table
  }));

  const handleBack = () => {
    resetFormFields();
    handleGetTWMslab();
    setSuccessPopUp(false);
    setOpenApprovalModal(false);
    setIsEditMode(false);
  };

  const viewUserHeading = (
    <div className={classes.slabModalHeader}>
      <HeaderTitle
        titleText={"Add Slab Range" || <MoreHoriz sx={{ fontSize: "30px" }} />}
        customclass={classes.heading_pop_pup}
      />
      <button type="button" className={classes.slabCloseButton} onClick={handleCloseAddItem}>
        <Close sx={{ fontSize: 18 }} />
      </button>
    </div>
  );

  const handleCloseViewItemPopup = () => {
    setOpenViewItemPopup(false);
  };

  const filteredData = processedItemsData.filter((item) => {
    if (!searchQuery) return true;

    const query = searchQuery.toLowerCase();
    return (
      (item.slab_name && item.slab_name.toLowerCase().includes(query)) ||
      (item.users && item.users.toLowerCase().includes(query)) ||
      (item.price_start && item.price_start.toString().includes(query)) ||
      (item.price_end && item.price_end.toString().includes(query))
    );
  });

  useEffect(() => {
    const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRaw) return;

    const { action, buyerAdmin_approverRange_search } =
      JSON.parse(chatActionRaw);

    if (action === "search_twm_approver_range") {
      if (!filteredData || filteredData.length === 0) return;

      console.log(buyerAdmin_approverRange_search?.searchText);
      setSearchQuery(buyerAdmin_approverRange_search?.searchText || "");

      sessionStorage.removeItem("CHAT_ACTION");
    }

    if (action === "add_twm_approver_range") {
      handleOpenAddItem();
    }
  }, [filteredData]);

  const viewItemsActionButtons = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleCloseViewItemPopup}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
    />,
    <Dbutton
      label={"OK"}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      onClick={handleCloseViewItemPopup}
    />,
  ];

  const viewUserChildren = [
    <InfoLabel
      size={"44%"}
      label={"Stage Name"}
      value={uniqueData?.slab_name}
    />,
    <InfoLabel
      size={"44%"}
      label={"Start price"}
      value={formatInrAmount(uniqueData?.price_start)}
    />,
    <InfoLabel
      size={"44%"}
      label={"End Price"}
      value={formatInrAmount(uniqueData?.price_end)}
    />,
    <InfoLabel
      size={"44%"}
      label={"Approvers"}
      value={
        uniqueData?.usersList ? (
          <ul className={classes.viewApproverList}>
            {uniqueData.usersList.map((user, index) => (
              <li key={index} className={classes.viewApproverItem}>
                {user.approver_name}
              </li>
            ))}
          </ul>
        ) : (
          "-"
        )
      }
    />,
  ];

  const handleOpenViewItemPopup = (unique_id) => {
    console.log(unique_id);
    let rowData = getUniqueData(processedItemsData, "id", unique_id.id);

    setUniqueData(rowData);
    setOpenViewItemPopup(true);
  };

  const handleEditAddItem = (editData = null) => {
    resetFormFields();

    if (editData) {
      setIsEditMode(true);
      setEditSlabId(editData.id);

      setStageName({
        value: String(editData.slab_name || "").slice(0, STAGE_NAME_MAX_LENGTH),
        isValid: true,
      });
      setStartPrice({ value: editData.price_start || "", isValid: true });
      SetEndPrice({ value: editData.price_end || "", isValid: true });
      setFromCurrency({
        currency: editData.currency_type || "",
        countryName: editData.country_name || "",
      });

      // 👉 Map ALL users to selectedApprovers (no level splitting)
      const matchedApprovers = editData.usersList
        .map((user) => {
          const match = getuserlist.find(
            (u) =>
              `${u.first_name || ""} - ${u.designation || ""}`.trim() ===
              user.approver_name.trim()
          );
          return match || null;
        })
        .filter(Boolean);

      setSelectedApprovers(matchedApprovers);
      setApprovers([]); // clear dynamic list if not using it
      const editDepartmentName =
        editData.department || editData.dept_name || matchedApprovers[0]?.department;
      const editDepartment = departmentList.find(
        (department) =>
          normalizeDepartment(department?.name) ===
          normalizeDepartment(editDepartmentName),
      );
      setSelectedDepartment(editDepartment || null);
    } else {
      setIsEditMode(false);
      setEditSlabId(null);
    }

    setOpenApprovalModal(true);
  };

  const handleDeleteSlab = async (row) => {
    const formData = new FormData();
    formData.append("id", row.id);
    formData.append("admin_token", user_token);

    try {
      const response = await axios.post(
        API_ENDPOINT.delete_twm_slab_config,
        formData,
        {
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        }
      );

      if (response.status === 200) {
        handleGetTWMslab(); // refresh table
      }
    } catch (error) {
      console.error(
        "Error deleting TWM slab:",
        error.response?.data || error.message
      );
    }
  };

  return (
    <div className={classes.slab_tab_wrapper}>
      <HeaderTitle titleText={"Invoice Process Approval Matrix"} />

      <div className={classes.search_add_wrapper}>
        <SearchBar
          value={searchQuery}
          onChange={(query) => {
            setSearchQuery(query);
            // setPageNumber(1);
          }}
          placeholder="Search by Name, Users, Price..."
        />

        <Dbutton
          labelImg={plusIcon}
          iconWidth="1rem"
          iconHeight="1rem"
          label="Invoice APPROVAL MATRIX"
          btnHeight="4rem"
          onClick={handleOpenAddItem}
        />
      </div>

      {/* 553,558 */}

      <div className={classes.d_dataTable}>
        <DataTable
          headings={Tableheadings}
          tableData={filteredData}
          actions={true}
          stickyHead={true}
          stickyFirstColumn={true}
          stickyFirstColumnOffset={0}
          tableSize={itemsData?.length === 0 ? "100%" : "100%"}
          viewBtn={true}
          sorting={true}
          viewClick={(token, row) => handleOpenViewItemPopup(row)}
          editBtn={true}
          editClick={(token, row) => handleEditAddItem(row)}
          deleteBtn={true}
          deleteClick={(token, row) => handleDeleteSlab(row)}
          setSortingColumnName={setSortingColumnName}
          sortingColumnName={sortingColumnName}
          setSortingOrder={setSortingOrder}
          sortingOrder={sortingOrder}
          serverSortableFields={SERVER_SORTABLE_FIELDS}
          viewTooltip={"View"}
        />
        <PaginationComponent
          pageNumber={pageNumber}
          currentPage={pageNumber}
          itemsPerPage={paginationData?.current_page_count || 0}
          totalItems={paginationData?.page_count || 0}
          setPageNumber={setPageNumber}
          previouPageClick={() => previouPageClick(pageNumber, setPageNumber)}
          nextPageClick={() =>
            nextPageClick(pageNumber, setPageNumber, paginationData)
          }
          disablePrevious={Number(pageNumber) <= 1}
          disableNext={
            Number(pageNumber) >= Number(paginationData?.page_count || 0)
          }
        />
      </div>

      <Modal
        open={openapprovalmodal}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
        sx={{
          overflow: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <Fade>
          <PopupFrame
            poupHeading={viewUserHeading}
            actionButtons={viewTextActionButtons}
            inputChildren={PoslabItemInputs}
            customClass={classes.slabModalCard}
            styleCenterDiv={classes.slabModalBody}
            actionButtonsClass={classes.slabFooterActions}
          />
        </Fade>
      </Modal>

      <Modal
        open={openViewItemPopup}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
      >
        <Fade in={openViewItemPopup}>
          <div
            className={classes.flex}
            style={{
              height: "130vh",
            }}
          >
            <PopupFrame
              inputChildren={viewUserChildren}
              poupHeading={viewUserHeading}
              actionButtons={viewItemsActionButtons}
              closePopup={handleCloseViewItemPopup}
              width={"auto"}
              customClass={classes.addPopup}
              styleCenterDiv={classes.centerDiv}
            />
          </div>
        </Fade>
      </Modal>

      <Modal
        open={successpopup}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <Fade in={successpopup}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText={`${
                isEditMode
                  ? "PR Approval Slab Updated!!"
                  : "PR Approval Slab Created!!"
              }`}
              popupDescription={`${
                isEditMode
                  ? "PR slab configuration updated successfully"
                  : "PR slab configuration saved successfully"
              }`}
              popBtn={true}
              vendorBtn={true}
              btnText={"Okay"}
              btnClick={handleBack}
            />
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
